export default "__VITE_ASSET__bb36fe39__"